<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import TtAccordion from '@/components/TtAccordion.vue'
import LogoIconGray from '@/components/Logo/LogoIconGray.vue'
import ProfilePicture from '@/components/Icon/ProfilePicture.vue'

const { t } = useI18n({ useScope: 'global' })

const sortedReviews = [
  {
    id: '1',
    user: {
      firstname: 'John',
      lastname: 'Doe',
    },
    rating: 5,
    comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    age: '4 dagar sedan'
  },
  {
    id: '2',
    user: {
      firstname: 'Jane',
      lastname: 'Doe',
    },
    rating: 4,
    comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    age: '3 dagar sedan'
  },
]
</script>

<template>
<div class="mx-5 mb-5 border-b border-black/10 pb-5">
  <TtAccordion :closed="false">
    <template v-slot:accordionButton>
      <div class="flex w-full items-center justify-between gap-1.5">
        <h2 class="text-lg font-semibold leading-9 tracking-tight">
          {{ t('location.reviews') }}
        </h2>
        <div class="flex flex-1 items-center justify-between">
          <div class="flex items-center gap-1">
            <LogoIconGray class="h-3.5 w-3.5" />
            <p class="text-[0.5rem] font-semibold">Trusted Truckers</p>
          </div>
          <div class="flex items-center gap-1">
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.63335 0.494309L4.81946 4.17209L0.761125 4.76376C0.0333466 4.86931 -0.25832 5.76654 0.269458 6.28043L3.20557 9.14154L2.51113 13.1832C2.38613 13.9138 3.15557 14.461 3.80002 14.1193L7.43058 12.211L11.0611 14.1193C11.7056 14.4582 12.475 13.9138 12.35 13.1832L11.6556 9.14154L14.5917 6.28043C15.1195 5.76654 14.8278 4.86931 14.1 4.76376L10.0417 4.17209L8.2278 0.494309C7.9028 -0.161247 6.96113 -0.169581 6.63335 0.494309Z"
                fill="#00E1A5"
              />
            </svg>
            <p class="font-medium">4</p>
          </div>
        </div>
      </div>
    </template>
    <div class="grid gap-1.5 pt-3">
      <blockquote
        v-for="review in sortedReviews"
        :class="`flex ${
          review.comment
            ? 'flex-col-reverse'
            : 'flex-row-reverse items-center'
        } gap-1.5 rounded border-black/10 bg-tt-lighter-gray px-4 ${
          review.comment ? 'pb-6 pt-4.5' : 'pb-4 pt-4'
        } `"
      >
        <div
          class="flex flex-1 items-center justify-between text-sm font-light"
        >
          <div
            :class="`flex items-center gap-1 ${
              review.comment ? 'ml-0' : 'ml-1.5'
            }`"
          >
            <span>{{ review.age }}</span>
          </div>

          <cite
            class="flex items-center gap-2 pr-3 text-sm font-medium not-italic tracking-tight text-tt-gray"
          >
            <span className="whitespace-nowrap">
              {{
                review.user.firstname +
                (review.user.lastname &&
                  ` ${review.user.lastname.substring(0, 1)}.`)
              }}
            </span>
            <ProfilePicture
              class="h-6 w-6 rounded-full"
            />
          </cite>
        </div>
        <p
          v-if="review.comment"
          class="pb-2.5 text-base font-light leading-relaxed tracking-tight"
        >
          {{ review.comment }}
        </p>
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-1.5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="13"
              fill="none"
              viewBox="0 0 14 13"
              :class="`${
                review.rating > 1 ? 'text-tt-green' : 'text-tt-gray/40'
              }`"
            >
              <path
                fill="currentColor"
                d="M6.24896557,0.452219291 L4.54018546,3.8135228 L0.717019719,4.35427888 C0.0314140581,4.45074618 -0.243351272,5.27076846 0.253843457,5.7404376 L3.01981591,8.35534564 L2.36561678,12.0492159 C2.24786019,12.7169469 2.97271327,13.2170597 3.57981918,12.9047634 L7,11.1606749 L10.4201397,12.9047634 C11.0272928,13.2145006 11.7521082,12.7169469 11.6343516,12.0492159 L10.9801901,8.35534564 L13.7461513,5.7404376 C14.2433667,5.27076846 13.9685699,4.45074618 13.2829439,4.35427888 L9.45981114,3.8135228 L7.75102162,0.452219291 C7.44485447,-0.146925325 6.55775163,-0.154542174 6.24896557,0.452219291 Z"
              />
            </svg>
            <span class="pl-0.5 text-base font-medium">{{
              review.rating
            }}</span>
          </div>
        </div>
      </blockquote>
    </div>
  </TtAccordion>
</div>
</template>
